<div class="watch-overlay" *ngIf="isOpen">
  <button class="watch-backdrop" type="button" aria-label="Close shared posts" (click)="close()"></button>

  <section class="watch-panel" role="dialog" aria-modal="true" aria-label="Shared posts">
    <header class="watch-header">
      <div class="watch-spacer" aria-hidden="true"></div>

      <div class="watch-title-wrap">
        <span class="watch-heading">Shared Posts</span>
      </div>

      <button class="close-btn" type="button" (click)="close()" aria-label="Close shared posts">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </header>

    <!-- Toast notification -->
    <div class="watch-toast" *ngIf="toastMessage" [class.toast-red]="toastColor === 'red'">
      {{ toastMessage }}
    </div>

    <div class="watch-content">
      <!-- Skeleton loading cards -->
      <ng-container *ngIf="loading && feedItems.length === 0">
        <div class="skeleton-item" *ngFor="let s of skeletonItems">
          <div class="skeleton-row">
            <div class="skeleton-avatar"></div>
            <div class="skeleton-info">
              <div class="skeleton-line wide"></div>
              <div class="skeleton-line narrow"></div>
            </div>
            <div class="skeleton-pill"></div>
          </div>
          <div class="skeleton-subtitle"></div>
        </div>
      </ng-container>

      <div class="empty-state" *ngIf="!loading && groupedFeedItems.length === 0">
        No shared posts found.
      </div>

      <ng-container *ngFor="let section of groupedFeedItems">
        <div class="section-label">{{ section.label }}</div>

        <div class="watch-item" *ngFor="let item of section.items" (click)="onItemMapClick(item, $event)">
          <!-- Avatar + Info + Tag + Hide button row -->
          <div class="item-row">
            <!-- Stacked avatar: fleet (large) + author (small) when fleet post; single avatar otherwise -->
            <div class="avatar-stack" *ngIf="item.communityName; else singleAvatar">
              <div class="avatar-circle has-photo" *ngIf="item.communityAvatarUrl; else communityInitials">
                <img [src]="item.communityAvatarUrl" class="avatar-photo" alt="" />
              </div>
              <ng-template #communityInitials>
                <div class="avatar-circle">
                  <span class="avatar-initials">{{ item.avatarInitials }}</span>
                </div>
              </ng-template>
              <div class="avatar-circle avatar-small" [class.has-photo]="!!item.authorAvatarUrl">
                <img *ngIf="item.authorAvatarUrl" [src]="item.authorAvatarUrl" class="avatar-photo" alt="" />
                <span *ngIf="!item.authorAvatarUrl" class="avatar-initials">{{ item.authorAvatarInitials }}</span>
              </div>
            </div>
            <ng-template #singleAvatar>
              <div class="avatar-circle" [class.has-photo]="!!item.avatarUrl">
                <img *ngIf="item.avatarUrl" [src]="item.avatarUrl" class="avatar-photo" alt="" />
                <span *ngIf="!item.avatarUrl" class="avatar-initials">{{ item.avatarInitials }}</span>
              </div>
            </ng-template>

            <div class="item-info" [class.item-info--column]="item.communityName">
              <span class="user-name">{{ item.name }}</span>
              <!-- Fleet post: "AuthorName · time" on its own line below the fleet name -->
              <span class="time" *ngIf="item.communityName">{{ item.authorName }} · {{ item.time }}</span>
              <span class="time" *ngIf="!item.communityName">{{ item.time }}</span>
            </div>

            <div class="item-actions">
              <div class="pill-tag" *ngIf="item.tag">
                <img [src]="item.tagIcon" class="tag-icon" [class.trip-tag-icon]="item.postType === 'trips'"
                  [class.colored-tag-icon]="item.tagTone === 'colored'" alt="" />
                <span>{{ item.tag }}</span>
              </div>
            </div>
          </div>

          <!-- Subtitle / description below the row -->
          <div class="item-body">
            <div class="subtitle" *ngIf="item.subtitle && item.postType !== 'trips'">
              {{ item.subtitle }}
            </div>

            <div class="trip-description" *ngIf="item.postType === 'trips' && item.description">
              <p class="trip-description-text" [class.expanded]="item.descriptionExpanded">
                {{ item.description }}
              </p>
              <button class="trip-more-btn" type="button" *ngIf="item.hasLongDescription"
                (click)="toggleTripDescription(item, $event)">
                {{ item.descriptionExpanded ? 'Show Less' : 'Show More' }}
              </button>
            </div>
          </div>

          <!-- Hide from me — bottom-right of each post -->
          <div class="item-hide-row" (click)="$event.stopPropagation()">
            <button class="hide-bottom-btn" type="button" (click)="onHideClick(item, $event)">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                <line x1="1" y1="1" x2="23" y2="23"/>
              </svg>
            </button>
          </div>
        </div>
      </ng-container>

      <div class="load-more" *ngIf="loadingMore && feedItems.length > 0">
        Loading more...
      </div>

      <div #scrollSentinel class="scroll-sentinel" aria-hidden="true"></div>
    </div>

    <!-- Confirmation dialog (rendered inside the panel for proper stacking) -->
    <div class="hide-dialog-backdrop" *ngIf="hideConfirmItem" (click)="cancelHide()">
      <div class="hide-dialog-card" (click)="$event.stopPropagation()">
        <p class="hide-dialog-title">Delete?</p>
        <p class="hide-dialog-body">Delete this from your map and watch feed? This only affects your account.</p>
        <div class="hide-dialog-actions">
          <button class="hide-dialog-btn cancel" type="button" (click)="cancelHide()">Cancel</button>
          <button class="hide-dialog-btn confirm" type="button" (click)="confirmHide()">Hide</button>
        </div>
      </div>
    </div>
  </section>
</div>
